
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["lucide lucide-pencil-sparkles-icon lucide-pencil-sparkles",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 3H8"}}),_c('path',{attrs:{"d":"m15.007 5.008 3.987 3.986"}}),_c('path',{attrs:{"d":"M20 15v4"}}),_c('path',{attrs:{"d":"M21.174 6.813a2.82 2.82 0 0 0-3.986-3.987L3.842 16.175a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z"}}),_c('path',{attrs:{"d":"M22 17h-4"}}),_c('path',{attrs:{"d":"M4 5v4"}}),_c('path',{attrs:{"d":"M6 7H2"}}),_c('path',{attrs:{"d":"M9 2v2"}})])
          )
        }
      }
    